(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["benefits-collection-activity-offers"] && !window.DesignMode) return;
  try {
    
;
(function (){
    "use strict";

    $(".benefits-collection-activity-offers a").on("click", function (e) {
        const $this = $(this);
        const link = location.origin + $this.attr("href");
        const buttonName = $this.find("h3").text().trim();

        const $tabsNav = $this.closest("jky-v-tabs-content").prev();
        let position = "";
        let module = "ActivityBasedOffers"
        if ($tabsNav.length) {
            position = $tabsNav.find(".navigation-item.active").text().trim();
            module = $tabsNav.prev().find(".blocks-content-heading").find("div:first-child").text().trim();
        }

        window.dataLayer.push({event_parameters: null});
        window.dataLayer.push({
            event: "ga4Event",
            event_name: "promo_collection_user_clicks",
            event_parameters: {
                current_page: window.location.href,
                module: module,
                position: position,
                button_name: buttonName,
                link: link
            }
        });
    });

    const initSwiper = (swiper) => {
        new Swiper(swiper, {
            slidesPerView: 'auto',
            pagination: {el: '.benefits-collection-activity-offers .swiper-pagination', clickable: true},
            spaceBetween: 24,
            navigation: {
                nextEl: '.benefits-collection-activity-offers .swiper-button-next',
                prevEl: '.benefits-collection-activity-offers .swiper-button-prev',
            },
            breakpoints: {
                1400: {
                    spaceBetween: 20,
                },
                1024: {
                    spaceBetween: 15,
                }
            }
        });
    };

    const init = () => {
        const url = "/osadminapi/v1/old-invite-new/get-coupon-info?shopifyShopId=" + window.shopId;
        window.Jackery.Utils.get(url).then(function (res) {
            if (res && res.code === 200) {
                const data = res.data;
                document.querySelectorAll('.benefits-collection-activity-offers .swiper').forEach(swiper =>  {
                    const $swiper = $(swiper);
                    $swiper.find(".description").each(function() {
                        const newHtml = $(this).html()
                            .replace("{new_subscribe_welfare}", data.newSubscribeTitle)
                            .replace("{old_subscribe_welfare}", data.newSubscribeToOldTitle)
                            .replace("{old_purchase_welfare}", data.newPurchaseToOldTitle);
                        $(this).html(newHtml);
                    });
                    let slidesCond = 3;
                    if (window.Jackery.Utils.isLessThan1024Screen()) {
                        slidesCond = 1;
                    }
                    if ($swiper.find(".swiper-slide").length > slidesCond) {
                        initSwiper(swiper);
                    } else {
                        $swiper.addClass("not");
                    }
                });
            }
        }).catch(function (err) {
            console.error("Get titles failed:", err);
        });
    };

    document.addEventListener('DOMContentLoaded', () => init());

    document.addEventListener('shopify:section:load', () => init());
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["benefits-collection-coupons-display"] && !window.DesignMode) return;
  try {
    
;(function(){
    "use strict";

        document.addEventListener('DOMContentLoaded', () => {
            if (Jackery.Utils.isMobile()) {
                document.querySelectorAll('.benefits-collection-coupons-display .swiper').forEach(swiper => {
                    new Swiper(swiper, {
                        slidesPerView: 'auto',
                        pagination: {el: '.swiper-pagination', clickable: true}
                    });
                });
            }
        });

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["benefits-collection-promo-product"] && !window.DesignMode) return;
  try {
    
;
(function () {
  "use strict";

  $(document).on("click", ".benefits-collection-promo-product jds-button", function (e) {
    const module = getModule($(this));
    const button_name = $(this).text();
    const link = location.origin + $(this).attr("href");
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: "ga4Event",
      event_name: "promo_collection_user_clicks",
      event_parameters: {
        current_page: window.location.href,
        module: module,
        button_name: button_name,
        link: link
      }
    });
  });

  $(document).on("click", ".benefits-collection-promo-product a", function (e) {

    const module = getModule($(this));

    const link = $(this).attr("href");
    const position = $(this).closest(".flex__item").find('.product-title').text();

    let button_name = 'pic';
    if ($(this).parent().hasClass('product-content')) {
      button_name = $(this).closest('.product-flex__list').data('productButtonText') || "VIEW MORE";
    }

    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: "ga4Event",
      event_name: "promo_collection_user_clicks",
      event_parameters: {
        current_page: window.location.href,
        module: module,
        position: position,
        button_name: button_name,
        link: link
      }
    });
  });

  function getModule($this) {
    const $prevSection = $this.closest('.benefits-collection-promo-product').parent().prev();
    let module = 'InstantDeals';
    if ($prevSection.attr('id').indexOf('benefits_collection_common_title') !== -1) {
      module = $prevSection.find(".title").text();
    }
    return module;
  }

  function initProducts() {
    const $productList = $(".benefits-collection-promo-product .product-flex__list");
    $productList.each(function () {
      const $this = $(this);
      if ($this.children().length == 0) {
        const url = "/osadminapi/v1/goods/get-sales-rank-goods-list?limit=4&shopifyShopId=" + window.shopId + "&categoryNumList=" + $this.data("productCategories");
        window.Jackery.Utils.get(url).then(function (res) {
          if (res && res.code === 200) {
            const product = {};
            const buttonText = $this.data("productButtonText") || "VIEW MORE";
            const autoDiscountPrice = $this.data("autoDiscountPrice");
            const discountDisplayStyle = $this.data("discountDisplayStyle");
            const discountAmountDisplayStyle = $this.data("discountAmountDisplayStyle");
            const discountTagDisplayStyle = $this.data("discountTagDisplayStyle");
            for (let i = 0; i < res.data.length; i++) {
              const product = res.data[i];
              const productUrl = location.origin + "/products/" + product.handle + "?variant=" + product.skuId;
              let productLabel = '';
              if (product.promotion) {
                productLabel = product.promotion
              } else {
                if (autoDiscountPrice && product.priceOff > 0) {
                    if (discountTagDisplayStyle === 'amount') {
                        const money = formatMoney(parseFloat(product.autoDiscountAmount)).split('.')[0];
                        productLabel = discountAmountDisplayStyle.replace('()', money);
                    } else {
                        productLabel = discountDisplayStyle.replace('()', product.priceOff);
                    }
                }
              }
              const price = product.price ? formatMoney(parseFloat(product.price)) : '';
              const originalPrice = product.originalPrice ? formatMoney(parseFloat(product.originalPrice)) : `<span class="opacity-0">&nbsp;</span>`;
              let domHtml =
                `<div class="flex__item h-[19.125rem] lg:h-[28rem] w-[10.47rem] lg:w-[19.5625rem]">
                  <div class="relative rounded-[0.375rem] lg:rounded-xl flex flex-col justify-between px-[0.5rem] lg:px-5 bg-white h-full">
                    <a href="${productUrl}" target="_blank">
                      <div class="product-img focus-zoom-container overflow-hidden pt-[0.25rem] lg:pt-0 w-[8.25rem] lg:w-[16.25rem] h-[8.25rem] lg:h-[16.25rem] mx-[0.625rem] lg:mx-[0.375rem]">
                        <img class="object-cover focus-zoom blur-up lazyload w-full" src="${product.image}" data-src="${product.image}" alt="" loading="lazy">
                      </div>
                    </a>
                    <div class="product-content flex flex-col pt-[0.125rem] lg:pt-[0.5625rem]">
                      <div class="product-content-main flex flex-col justify-between">
                        <div class="product-title h-[2.6875rem] lg:h-[3.5rem] font-medium text-[0.875rem] leading-[1.375rem] lg:text-[1rem] text-[#1A1A1A] lg:leading-[1.625rem] text-overflow-2 mb-[0.78rem] lg:mb-4">
                          ${product.title}
                        </div>
                        <div class="product-prices flex flex-col lg:flex-row lg:items-center gap-[0.5rem] lg:gap-2">
                          <div class="price price--on-sale font-semibold text-[1.125rem] lg:text-2xl text-[#FD5000] leading-[1.5rem] lg:leading-8">
                            <div class="real-price">${price}</div>
                          </div>
                          <div class="origin-price font-400 origin-compare-price font-normal text-[0.875rem] lg:text-base text-[#999999] lg-[0.75rem] lg:leading-6 line-through">
                            ${originalPrice}
                          </div>
                        </div>
                      </div>
                      <a class="flex items-center justify-center w-full h-[2rem] lg:h-9 border rounded-[1.125rem] bg-[#FD5000] border-solid border-[#FD5000] mt-[0.5rem] mb-[1rem] lg:mt-[1rem] lg:mb-6
                                                font-medium lg:font-semibold lg:text-base text-[0.75rem] text-white leading-[1.25rem] lg:leading-4"
                         href="${productUrl}"
                         target="_blank">${buttonText}</a>
                    </div>
                    <div class="product-label-tag product-tag-text">
                      <span class="product-label-tag-text">${productLabel}</span>
                    </div>
                    `;
              if (product.icon) {
                domHtml += `<div class="product-label-tag product-tag-img">
                              <img src="${product.icon}" alt="product tag image" loading="lazy">
                            </div>
                        </div></div>`;
              } else {
                domHtml += `</div></div>`;
              }
              $this.append(domHtml);
            }
          }
        }).catch(function (err) {
            console.error("Get products failed:", err);
        });
      }
    });
  }

  document.addEventListener('shopify:section:load', initProducts);

  document.addEventListener('DOMContentLoaded', initProducts);

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["benefits-collection-special-group"] && !window.DesignMode) return;
  try {
    
;
$(function () {
    "use strict";

    $(".benefits-collection-special-group jds-button").on("click", function () {
        const $this = $(this);
        const $titleComp = $this.closest('.benefits-collection-special-group').parent().prev();
        let module = "SpecialGroupBenefits";
        if ($titleComp.attr("id") && $titleComp.attr("id").indexOf("benefits_collection_common_title") !== -1) {
            module = $titleComp.find('.title').text().trim() || module;
        }
        let position = "";
        try {
            position = $this.parent().parent().prev().find(".blocks-content-heading").find("div:first-child").text().trim();
        } catch (e) {}
        const buttonName = $this.text().trim();
        let link = $this.attr("href");
        if (link) {
            link = location.origin + link;
        } else {
            link = "";
        }

        window.dataLayer.push({event_parameters: null});
        window.dataLayer.push({
            event: "ga4Event",
            event_name: "promo_collection_user_clicks",
            event_parameters: {
                current_page: window.location.href,
                module: module,
                position: position,
                button_name: buttonName,
                link: link
            }
        });
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-v3-banner"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const blogV3Banners = document.querySelectorAll('.blog-v3-banner');
    if (blogV3Banners.length === 0) return;

    blogV3Banners.forEach((item) => {
      const itemId = item.getAttribute('id');
      const autoplay = item.getAttribute('data-autoplay') === 'true';
      const delay = Number(item.getAttribute('data-delay')) || 7;

      const swiper = new Swiper(`#${itemId} .swiper`, {
        slidesPerView: 'auto',
        spaceBetween: 0,
        centeredSlides: true,
        loop: true,
        speed: 600,
        followFinger: false,
        keyboard: true,
        autoplay: autoplay
          ? {
              delay: delay * 1000,
              disableOnInteraction: false,
              reverseDirection: false,
            }
          : false,
        navigation: {
          nextEl: `#${itemId} .swiper-button-next`,
          prevEl: `#${itemId} .swiper-button-prev`,
        },
        pagination: {
          el: `#${itemId} .slideshow-pagination`,
          clickable: true,
          bulletClass: 'slideshow-pagination-item',
          bulletActiveClass: 'active pagination-active',
          clickableClass: 'slideshow-pagination-clickable',
          modifierClass: 'slideshow-pagination-modifier',
          renderBullet(index) {
            const loaderHtml =
              index <= 14
                ? '<span class="pagination-separator"><span class="pagination-separator-loader"></span></span>'
                : '';
            return `<span class="slideshow-pagination-item">${loaderHtml}</span>`;
          },
        },
        on: {
          init: function () {
            this.el.classList.remove('swiper-unload');
            this.el.classList.add('swiper-loaded');
          },
          paginationUpdate: function (swiper, paginationEl) {
            window.swiperAnimatePagination(paginationEl, autoplay, delay);
          },
        },
      });
    });

    // GA埋码
    document.querySelectorAll('.blog-v3-banner .swiper-slide').forEach((item) => {
      const dataJson = {
        module: 'BlogCarousel', // 固定为 BlogCarousel
        position: item.dataset.title, // 识别博客文章标题text
      };
      if (item.dataset.link) {
        // 完整跳转链接,未配置则为：null(非字符串)
        dataJson.link = location.origin + item.dataset.link;
      }
      item.querySelector('.swiper-img')?.addEventListener('click', function () {
        // 点击图片固定为ImageLink
        dataJson.button_name = 'ImageLink';
        gaPushDataLayer('blogs_collection_user_clicks', dataJson);
      });

      item.querySelector('.swiper-title')?.addEventListener('click', function () {
        // 点击文字固定为TitleLink
        dataJson.button_name = 'TitleLink';
        gaPushDataLayer('blogs_collection_user_clicks', dataJson);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ehb-caculator"] && !window.DesignMode) return;
  try {
    
    if (!customElements.get("ehb-calculator")) {
        class EhbCalculator extends HTMLElement {
            constructor() {
                super();
                this.__parent_dom = this.querySelector(".calculator-left")
            }
            connectedCallback() {
                this.getData()
                !this.render && this.renderModalTrigger()
            }
            getData() {
                this.info = this.info || JSON.parse(this.querySelector('[type="application/json"]').textContent);
                return this.info;
            }
            renderModalTrigger() {
                this.render = true
                const newDiv = document.createElement('div');
                newDiv.innerHTML = this.info.modal_btn ? `<div class="ehb-product-caculator--trigger flex items-center gap-x-3 lg:rounded-lg rounded-md max-w-80 lg:px-4 px-5 lg:py-6 py-3 cursor-pointer mt-3 lg:mt-0 lg:mb-0 mb-3">
                <div class="ehb-product-caculator--trigger-title text-sm lg:text-base font-semibold"><p><span class="underline">${this?.info?.modal_btn}</span></p></div>
                <div class="btn-icon"><jds-icon name="plus-line" class="icon text-3xl"></jds-icon></div>
                </div>` : ''
                newDiv.addEventListener("click", () => {
                    ZModle.getInstance(`
                        <div class="lg:px-9 text-center">
                            <div class="ehb-trigger-title lg:text-2xl text-lg font-medium text-black mb-4">${this?.info?.modal_title}</div>
                            <div class="ehb-trigger-des mb-2 lg:text-base text-sm">${this?.info?.modal_subtitle}</div>
                            <div class="w-full lg:max-h-96 max-h-80 overflow-y-auto">
                                ${this?.info?.has_modal_img === 'yes' ? `<img class="w-full h-auto" src="${this?.info?.modal_img}" alt="${this?.info?.modal_img_alt}" />` : '' }
                        
                            </div>
                        </div>
                    `, {
                        id: "ehb-product-caculator-modal",
                        class: "ehb-product-caculator--modal"
                    })
                })
                if (this.__parent_dom) {
                    this.__parent_dom.appendChild(newDiv); 
                }
            }
        }
        customElements.define('ehb-calculator', EhbCalculator);
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-new"]) return;
  try {
    
  function toGA(data){
    if(data.response && data.response.code === 200){
      const msg = $('.footer-new .newbee-form_submit button').data('success') || data.response.message
      pushSuccessMessage(msg);
      const button_name =$('.footer-new .newbee-form_submit button').text()
      let params ={
        module: 'Footer Subscribe',
        button_name: button_name
      }

      window.dataLayer.push({ event_parameters: null });
        window.dataLayer.push({
          event: "ga4Event",
          event_name: "footer_user_clicks4.0",
          event_parameters: {
            current_page: window.location.href, // current page url
            ...params
          }
        });
    }
    
  }
  window.toGA = toGA

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-text-one-line"] && !window.DesignMode) return;
  try {
    
  // 遍历页面中所有的v-image-text-one-line-section组件
  const imageTextOneSections = document.querySelectorAll('.v-image-text-one-line-section');
  
  imageTextOneSections.forEach((section, sectionIndex) => {
    // 遍历当前section中的所有v-image-text-one-line-block
    const imageTextBlocks = section.querySelectorAll('.v-image-text-one-line-block');
    
    imageTextBlocks.forEach((block, blockIndex) => {
      // 查找当前block中的所有jds-button
      const jdsButtons = block.querySelectorAll('jds-button');
      
      jdsButtons.forEach((button, buttonIndex) => {
        // 为每个jds-button添加点击事件
        button.addEventListener('click', (e) => {
          // 获取按钮文案
          const buttonText = button.textContent.trim();
          
          // 获取跳转链接
          const linkElement = button.querySelector('a') || button;
          const href = linkElement.getAttribute('href') || linkElement.getAttribute('data-href') || '无链接';

          // 获取前一个 blocks-heading-content 组件中的标题文本
          let prevHeadingText = {
            pc: '',
            mb: ''
          };
          
          // 查找当前 section 的前一个兄弟元素
          let prevSection = section.previousElementSibling;
          
          // 遍历前面的兄弟元素，查找包含 blocks-heading-content 的组件
          while (prevSection) {
            const headingContentBlock = prevSection.querySelector('.blocks-heading-content');
            if (headingContentBlock) {
              // 查找 blocks-content-heading 元素
              const headingElement = headingContentBlock.querySelector('.blocks-content-heading');
              if (headingElement) {
                // 获取 PC 端文本（lg:block 显示的内容）
                const pcElement = headingElement.querySelector('.hidden.lg\\:block');
                if (pcElement) {
                  prevHeadingText.pc = pcElement.textContent.trim();
                }
                
                // 获取 MB 端文本（lg:hidden 显示的内容）
                const mbElement = headingElement.querySelector('.block.lg\\:hidden');
                if (mbElement) {
                  prevHeadingText.mb = mbElement.textContent.trim();
                }
                
                break; // 找到第一个匹配的就停止
              }
            }
            prevSection = prevSection.previousElementSibling;
          }
          
          // 根据屏幕尺寸选择对应的文案
          const isDesktop = window.innerWidth > 1024;
          const selectedHeadingText = isDesktop ? prevHeadingText.pc : prevHeadingText.mb;
          
          // 新增：获取当前按钮的父节点button-wrapper的前一个兄弟节点blocks-heading-content中的另一个文本
          let additionalHeadingText = {
            pc: '',
            mb: ''
          };
          
          // 查找当前按钮的button-wrapper父节点
          let buttonWrapper = button.closest('.button-wrapper');
          
          if (buttonWrapper) {
            // 查找button-wrapper的前一个兄弟元素blocks-heading-content
            let prevSibling = buttonWrapper.previousElementSibling;
            
            while (prevSibling) {
              if (prevSibling.classList && prevSibling.classList.contains('blocks-heading-content')) {
                // 查找主标题文本元素
                  const mainHeadingElement = prevSibling.querySelector('.blocks-content-heading');
                  if (mainHeadingElement) {
                    // 获取 PC 端主标题文本
                    const pcMainElement = mainHeadingElement.querySelector('.hidden.lg\\:block');
                    if (pcMainElement) {
                      additionalHeadingText.pc = pcMainElement.textContent.trim();
                    }
                    
                    // 获取 MB 端主标题文本
                    const mbMainElement = mainHeadingElement.querySelector('.block.lg\\:hidden');
                    if (mbMainElement) {
                      additionalHeadingText.mb = mbMainElement.textContent.trim();
                    }
                  }
                break; // 找到第一个匹配的就停止
              }
              prevSibling = prevSibling.previousElementSibling;
            }
          }
          
          // 根据屏幕尺寸选择对应的附加文案
          const selectedAdditionalText = isDesktop ? additionalHeadingText.pc : additionalHeadingText.mb;
          
          // 构建埋点参数
          const gaParams = {
            module: selectedHeadingText,
            position: selectedAdditionalText,
            button_text: buttonText,
            link: href
          };
          
          // 调用埋点函数
          handleGAEvent(gaParams);
        });
      });
    });
  });

  // 埋码函数
  function handleGAEvent(params) {
    window.dataLayer.push({ "event_parameters": null });
    window.dataLayer.push({
      event:"ga4Event",
      event_name:"vimage_text_one_line_user_click",
      event_parameters:{
        current_page: window.location.href,
        ...params
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-photovolatic-media"] && !window.DesignMode) return;
  try {
    
;
(function(){
    "use strict";

    $(document).on('click', '.section-photovolatic-media .action-btn.next-action', function(e) {
        const $this = $(this).parent().parent();
        const $container = $this.find(".jky-tabs-scroll-inner");
        $container.css("scroll-behavior", "smooth")
        $container.scrollLeft($container.scrollLeft() + 120);
    });

    $(document).on('click', '.section-photovolatic-media .action-btn.prev-action', function(e) {
        const $this = $(this).parent().parent();
        const $container = $this.find(".jky-tabs-scroll-inner");
        $container.css("scroll-behavior", "smooth")
        $container.scrollLeft($container.scrollLeft() - 120);
    });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v-tabs-sections"] && !window.DesignMode) return;
  try {
    
if (!customElements.get("jky-v-tabs-content")) {
  class JkyVTabsContent extends HTMLElement {
    constructor() {
      super()
      this.navItemLength = 0
    }
    connectedCallback() {
      this.container = this.closest('.blocks-tabs-sections')
      this.tabContentWrap = this.querySelector('.tab-content-wrap')
      this.init()

      // 监听 子组件高度变化 事件
      this.updateChildHeight = this.updateChildHeight.bind(this)
      document.addEventListener('tabChildUpdateHeight', this.updateChildHeight)
    }
    disconnectedCallback() {
      // 移除事件监听
      document.removeEventListener('tabChildUpdateHeight', this.updateChildHeight)
    }
    init() {
      const vTabsNavigation = this.container?.querySelector('jky-v-tabs-navigation')
      if (!vTabsNavigation) return
      
      const navItems = vTabsNavigation.querySelectorAll('.navigation-item');
      this.navItemLength = navItems.length

      const groupNames = Array.from(navItems).map(item => item.dataset.groupName);
      groupNames.forEach(groupName => {
        // 创建一个新的 tab 内容容器
        const tabContent = document.createElement('div')
        tabContent.classList.add('tab-content', 'w-full', 'invisible')
        tabContent.setAttribute('data-group-name', groupName)
        // 将内容添加到对应的组中
        const groupTargets = document.querySelectorAll(`[belongs-to-target="${groupName}"]`)
        if (groupTargets.length > 0) {
          groupTargets.forEach((section, index) => {
            section.classList.remove('hidden')
            tabContent.appendChild(section)
            index === 0 && tabContent.classList.remove('invisible')
          });
        }
        this.tabContentWrap.appendChild(tabContent)
      })

      // 确保所有内容都已渲染
      this.tabContents = this.tabContentWrap.querySelectorAll('.tab-content')

      // 设置 tabContent 的宽度，以及 tab content wrap 的宽度、高度
      requestAnimationFrame(() => {
        if (this.navItemLength > 0) {
          const height = this.measureElement(this.tabContents[0])
          this.tabContentWrap.style.width = `${this.navItemLength * 100}%`
          this.tabContentWrap.style.height = `${height}px`
          this.tabContents.forEach((item, idx) => item.style.width = `${100 / this.navItemLength}%`)
        }
      })
    }
    // 计算元素高度
    measureElement(el) {
      const DOM = el.cloneNode(true)
      DOM.style.position = 'absolute';
      DOM.style.visibility = 'hidden';
      DOM.style.display = 'block'; // 确保不会是 display:none
      document.body.appendChild(DOM);

      const height = DOM.offsetHeight;

      document.body.removeChild(DOM);
      return height;
    }
    handleChildAction({ item, index, isActive }) {
      requestAnimationFrame(() => {
        this.tabContentWrap.style.transform = `translateX(-${index * 100 / this.navItemLength}%)`
        this.tabContentWrap.style.height = `${this.tabContents[index].offsetHeight}px`

        // 滚动到当前项
        const itemParent = item.closest('jky-v-tabs-navigation')
        const bottom = parseInt(itemParent?.getBoundingClientRect()?.bottom) || 0
        const top = parseInt(this.tabContentWrap.getBoundingClientRect().top) || 0
        window.scrollTo({
          top: top - bottom + window.scrollY,
          behavior: isActive ? 'smooth' : 'auto' // 只有点击当前项时才平滑滚动
        })

        this.tabContents.forEach((it, idx) => {
          if (idx === index) {
            it.classList.remove('invisible')

            // Safari 修复: 自动匹配 line-clamp-[n]
            const els = it.querySelectorAll('[class*="line-clamp-"]');
            if (!els.length) return;
            requestAnimationFrame(() => {
              // 过滤掉含有 lg:line-clamp-* 的元素
              const needFixEls = Array.from(els).filter(el =>
                Array.from(el.classList).some(c => /^line-clamp-\d+$/.test(c))
              );
              if (!needFixEls.length) return;

              // 先拉大
              needFixEls.forEach(el => {
                el.style.display = '-webkit-box';
                el.style.webkitBoxOrient = 'vertical';
                el.style.overflow = 'hidden';
                el.style.whiteSpace = 'normal';
                el.style.webkitTransform = 'translateZ(0)';
                el.style.webkitLineClamp = '999'; // 拉大，触发回流
              });

              requestAnimationFrame(() => {
                needFixEls.forEach(el => {
                  const match = Array.from(el.classList).find(c => /^line-clamp-(\d+)$/.test(c));
                  if (!match) return;
                  const n = +match.match(/\d+/)[0];

                  // 设回目标 clamp
                  el.style.webkitLineClamp = n;
                  void el.offsetHeight; // 强制 reflow
                });
              });
            });
          } else {
            it.classList.add('invisible')
          }
        })
      })
    }
    // 更新子组件高度
    updateChildHeight(e) {
      const { height } = e.detail;
      if (height >= 0) {
        this.tabContentWrap.style.height = `${height}px`;
      }
    }
  }
  customElements.define('jky-v-tabs-content', JkyVTabsContent);
}

  } catch(e) { console.error(e); }
})();
})();
